import { DateRangeBucketKey } from './get-dashboard-data-response';

export interface DateBucketSelectOption {
  code: DateRangeBucketKey;
  name: string;
}

export const DATE_BUCKET_SELECT_OPTIONS: DateBucketSelectOption[] = [
  { code: 'last_report', name: 'Last Report' },
  { code: '10_days', name: 'Last 10 Days' },
  { code: '1_month', name: '1 Month' },
  { code: '2_month', name: '2 Months' },
  { code: '3_month', name: '3 Months' },
  { code: '6_month', name: '6 Months' },
  { code: 'past_year', name: 'Past Year' },
  { code: 'year_to_date', name: 'Year to Date' },
];

export const DATE_RANGE_BUCKET_CODES = DATE_BUCKET_SELECT_OPTIONS.map((option) => option.code);
